import { Alert, AlertTitle } from "@mui/material";
import GridPage from "./layout/GridPage";

export default ({ title, message }: { title?: string; message?: string }) => {
  return (
    <GridPage>
      <Alert severity="warning">
        <AlertTitle>{title || "Page not found"}</AlertTitle>
        {message || "Requested page was not found."}
      </Alert>
    </GridPage>
  );
};
